export default __webpack_public_path__ + "static/media/invoice_bottom_left_red_bg.f1ca8ca4.svg";